export const invoicePaymentMethods = [
  { value: null, text: 'None' },
  { value: 'BANK_ONLY', text: 'Bank Only' },
  { value: 'CREDIT_CARD_PRIMARY', text: 'Credit Card Primary' },
];
